//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";

// component
import CheckBox from "../../../../component/button/CheckBox";
import BasicBtn from "../../../../component/button/BasicBtn";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MyEditDetail({ setNoMember, setComplModal }) {
    //페이지 이동
    const navigate = useNavigate();
    const MyEdit = () => {
        navigate(-1);
    };

    // 로그인 창 액티브 스타일
    const [pwdText, setPwdText] = useState(false);
    const [pwdText2, setPwdText2] = useState(false);
    const [recommendText, setRecommendText] = useState(false);

    return (
        <Wrap>
            <TitleWrap>
                <Title>개인정보수정</Title>
            </TitleWrap>

            <ContentBigWrap>
                <ContentWrap>
                    {/* id */}
                    <ContentList>
                        <InputWrap>
                            <InputTitle>아이디</InputTitle>
                            <IdInput type="text" defaultValue="sindoh1234" readOnly />
                        </InputWrap>
                    </ContentList>
                    {/* pwd1 */}
                    <ContentList>
                        <InputWrap>
                            <InputTitle>비밀번호</InputTitle>
                            <TextInputBox>
                                <TextInput
                                    active={pwdText.length > 0}
                                    onChange={(e) => {
                                        setPwdText(e.target.value);
                                    }}
                                    type="password"
                                    placeholder="비밀번호를 입력해주세요."
                                    required
                                />
                                {/* 조건에 따라 각각의 텍스트 노출해주세요! */}
                                <ErrorMsg>*비밀번호가 조건에 맞지않습니다.</ErrorMsg>
                                {/* <ErrorMsg>*비밀번호가 일치하지않습니다.</ErrorMsg> */}
                            </TextInputBox>
                        </InputWrap>
                    </ContentList>
                    {/* pwd2 */}
                    <ContentList>
                        <InputWrap>
                            <InputTitle>비밀번호 확인</InputTitle>
                            <TextInput
                                active={pwdText2.length > 0}
                                onChange={(e) => {
                                    setPwdText2(e.target.value);
                                }}
                                type="password"
                                placeholder="비밀번호를 입력해주세요."
                                required
                            />
                        </InputWrap>
                    </ContentList>
                    {/* name */}
                    <ContentList>
                        <InputWrap>
                            <InputTitle>이름</InputTitle>
                            <TextInput type="text" defaultValue="김신도" readOnly />
                        </InputWrap>
                    </ContentList>
                    {/* presenter */}
                    <ContentList>
                        <InputWrap>
                            <InputTitle>추천인</InputTitle>
                            <TextInput
                                active={recommendText.length > 0}
                                onChange={(e) => {
                                    setRecommendText(e.target.value);
                                }}
                                type="text"
                                defaultValue="shindo789"
                            />
                        </InputWrap>
                    </ContentList>
                </ContentWrap>
                <MarketingWrap>
                    <MarketingTitle>마케팅 정보 수신 및 활용 동의</MarketingTitle>
                    <MarketingCon>
                        <ChkWrap>
                            <CheckBox id="Email" withText={true} text="이메일" />
                        </ChkWrap>
                        <MarketingDesc>서비스의 중요 안내사항 및 주문/배송에 대한 정보는 위 수신 여부와 관계없이 발송됩니다.</MarketingDesc>
                    </MarketingCon>
                </MarketingWrap>
                <MemberOut to="/mypage/memberout">회원탈퇴하기</MemberOut>
            </ContentBigWrap>

            <BtnWrap>
                <BasicBtn
                    onClick={() => {
                        MyEdit();
                    }}
                    gray={true}
                    text="취소"
                />

                {/* 각각에 맞는 팝업 노출해주세요! */}

                {/* 1. 추천인이 없음 경고팝업! */}
                {/* <BasicBtn onClick={() => { setNoMember(true) }} text="확인"/> */}

                {/* 2. 수정완료 팝업 */}
                <BasicBtn
                    onClick={() => {
                        setComplModal(true);
                    }}
                    text="확인"
                />
            </BtnWrap>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const TitleWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-bottom: calc(100vw * (20 / 1920));
    border-bottom: 1px solid #000;

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(20)};
    }
`;

const Title = styled.h3`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const ContentBigWrap = styled.div`
    position: relative;
    width: calc(100vw * (625 / 1920));

    margin: 0 auto calc(100vw * (48 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (625 / 1300));
        margin: 0 calc(100vw * (48 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin: 0;
    }
`;

const ContentWrap = styled.ul`
    margin-bottom: calc(100vw * (55 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (55 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(55)};
    }
`;

const ContentList = styled.li``;

const InputWrap = styled.div`
    display: flex;
    align-items: baseline;

    margin-top: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        align-items: flex-start;
        flex-direction: column;
        margin-top: ${M(15)};
    }
`;

const InputTitle = styled.label`
    flex-shrink: 0;
    width: calc(100vw * (140 / 1920));
    font-size: calc(100vw * (15 / 1920));

    padding-left: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (120 / 1300));
        font-size: calc(100vw * (15 / 1300));
        padding-left: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        font-size: ${M(15)};
        padding-left: ${M(5)};
    }
`;
const TextInputBox = styled.div`
    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;
const TextInput = styled.input`
    flex-shrink: 0;
    width: calc(100vw * (510 / 1920));
    font-size: calc(100vw * (15 / 1920));

    padding: calc(100vw * (11 / 1920)) calc(100vw * (15 / 1920));
    background: #fafafa;
    border-radius: 4px;

    &:read-only {
        color: #777;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (510 / 1300));
        font-size: calc(100vw * (15 / 1300));

        padding: calc(100vw * (11 / 1300)) calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        font-size: ${M(15)};
        margin-top: ${M(10)};
        padding: ${M(11)} ${M(15)};
    }

    ${({ active }) =>
        active &&
        `
            color:#222;
            border: 1px solid var(--main-color);
            background: #fff;
        `};
`;

const IdInput = styled(TextInput)`
    @media screen and (max-width: 900px) {
        width: ${M(278)};
    }
`;

const ErrorMsg = styled.p`
    font-size: calc(100vw * (14 / 1920));
    margin-top: calc(100vw * (10 / 1920));
    color: #ef0000;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        margin-top: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-top: ${M(13)};
    }
`;

const MarketingWrap = styled.div``;

const MarketingTitle = styled.h4`
    font: calc(100vw * (15 / 1920)), "Noto-B";
    margin-bottom: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        font: calc(100vw * (15 / 1300)) "Noto-B";
        margin-bottom: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font: ${M(15)} "Noto-B";
        margin-bottom: ${M(10)};
    }
`;

const MarketingCon = styled.div`
    padding: calc(100vw * (25 / 1920)) calc(100vw * (20 / 1920)) calc(100vw * (20 / 1920));
    background: #fafafa;

    margin-bottom: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (25 / 1300)) calc(100vw * (20 / 1300)) calc(100vw * (20 / 1300));
        margin-bottom: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(25)} ${M(20)} ${M(20)};
        margin-bottom: ${M(10)};
    }
`;

const ChkWrap = styled.div`
    margin-bottom: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(25)};
    }
`;

const MarketingDesc = styled.p`
    font: calc(100vw * (14 / 1920)) "Noto-R";

    @media screen and (max-width: 1300px) {
        font: calc(100vw * (14 / 1300)) "Noto-R";
    }

    @media screen and (max-width: 900px) {
        font: ${M(14)} "Noto-R";
    }
`;

const MemberOut = styled(Link)`
    display: block;
    font-size: calc(100vw * (14 / 1920));
    text-align: right;
    text-decoration: underline;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
    }
`;

const BtnWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    & > p {
        flex-shrink: 0;
        width: calc(100vw * (200 / 1920));
    }

    & > p:first-child {
        margin-right: calc(100vw * (19 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (50 / 1300));
        & > p {
            width: calc(100vw * (200 / 1300));
        }

        & > p:first-child {
            margin-right: calc(100vw * (19 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(60)};

        & > p {
            width: ${M(160)};
        }

        & > p:first-child {
            margin-right: ${M(20)};
        }
    }
`;
